<template>
  <textarea
    v-model.trim="internalValue"
    v-bind="$props"
    v-autogrow
    :class="$style.textarea"
    rows="1"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @keydown.enter="$e => $emit('submit', $e)"
  />
</template>

<script>
import { escape, unescape } from 'lib/utils/string';
import { TextareaAutogrowDirective } from 'directives/textareaAutogrow';

export default {
  name: 'BaseTextarea',
  directives: {
    autogrow: TextareaAutogrowDirective,
  },
  props: {
    value: String,
  },
  data() {
    return {
      internalValue: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.internalValue = unescape(val);
      },
    },
    internalValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', escape(val), val);
      },
    },
  },
};
</script>

<style lang="sass" module>
  .textarea
    +size(100%, auto)
    +base-input
    resize: none
</style>
